import { useEffect, useRef, useState } from "react";
import { Monitor, Smartphone } from "lucide-react";
import { API, BACKEND_ORIGIN } from "@/lib/api";

export const LivePreview = ({ cid, config }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState(480);
  const [ready, setReady] = useState(false);
  const [device, setDevice] = useState("desktop");

  useEffect(() => {
    const onMsg = (e) => {
      if (e.origin !== BACKEND_ORIGIN) return;
      let d = e.data;
      if (typeof d === "string") {
        try {
          d = JSON.parse(d);
        } catch (x) {
          return;
        }
      }
      if (d && d.hkCalc && d.key === "preview") setHeight(d.height);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  useEffect(() => {
    if (!ready || !ref.current?.contentWindow) return;
    ref.current.contentWindow.postMessage(JSON.stringify({ hkPreview: 1, config }), BACKEND_ORIGIN);
  }, [config, ready]);

  const DeviceBtn = ({ id, Icon, label }) => (
    <button type="button" onClick={() => setDevice(id)} aria-label={label} title={label}
      className={`p-1.5 rounded transition-colors ${device === id ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}
      data-testid={`preview-device-${id}`}>
      <Icon className="w-4 h-4" />
    </button>
  );

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden" data-testid="live-preview">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-100 bg-slate-50">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <span className="relative flex w-2 h-2"><span className="absolute inline-flex w-full h-full rounded-full bg-emerald-400 opacity-75 animate-ping" /><span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-500" /></span>
          Live forhåndsvisning
        </div>
        <div className="flex gap-1 p-0.5 rounded-md bg-slate-200/70">
          <DeviceBtn id="desktop" Icon={Monitor} label="PC" />
          <DeviceBtn id="mobile" Icon={Smartphone} label="Mobil" />
        </div>
      </div>
      <div className="p-3 sm:p-5 bg-[repeating-linear-gradient(45deg,#f8fafc,#f8fafc_10px,#f1f5f9_10px,#f1f5f9_20px)]">
        <div className="mx-auto transition-[max-width] duration-300" style={{ maxWidth: device === "mobile" ? 375 : "100%" }}>
          <iframe
            ref={ref}
            title="Forhåndsvisning av kalkulator"
            src={`${API}/embed/${cid}?preview=1&k=preview`}
            onLoad={() => setReady(true)}
            scrolling="no"
            className="w-full border-0 block"
            style={{ height }}
            data-testid="live-preview-iframe"
          />
        </div>
      </div>
    </div>
  );
};
